import { createEvent, restore, sample } from 'effector'
import { PassCommissionRequest } from './types'
import { fx } from '../../../../../../libs'
import { $params } from '../../../../../../features/router'
import { WithdrawalEdit } from '../../../edit'
import { RequestError } from '../../../../../../shared/errorResponse'
import { setChangedAmountData } from '../changeAmountForm/model'

export const passCommissionCalculateSubmit =
  createEvent<PassCommissionRequest>()

export const passCommissionUpdateSubmit = createEvent<PassCommissionRequest>()

export const setPassCommissionUpdateRequestSuccess = createEvent<boolean>()

export const setError = createEvent<RequestError>()

export const $passCommissionUpdateRequestSuccess = restore(
  setPassCommissionUpdateRequestSuccess,
  false,
)

export const $error = restore(setError, {
  message: '',
  code: 0,
})

export const passCommissionCalculate = fx<
  PassCommissionRequest,
  WithdrawalEdit
>({
  method: 'PUT',
  url: `/transaction_request/transfer_vendor_commission_to_client/`,
})

export const passCommissionUpdate = fx<PassCommissionRequest, WithdrawalEdit>({
  method: 'PUT',
  url: `/transaction_request/transfer_vendor_commission_to_client/`,
})

sample({
  clock: passCommissionCalculateSubmit,
  source: $params,
  fn: (params, item) => {
    let id
    if (params) {
      id = params.withdrawalID
    }

    return {
      body: {
        ...item,
      },
      url: `/transaction_request/transfer_vendor_commission_to_client/${id}`,
    }
  },
  target: passCommissionCalculate,
})

sample({
  clock: passCommissionUpdateSubmit,
  source: $params,
  fn: (params, item) => {
    let id
    if (params) {
      id = params.withdrawalID
    }

    return {
      body: {
        ...item,
      },
      url: `/transaction_request/transfer_vendor_commission_to_client/${id}`,
    }
  },
  target: passCommissionUpdate,
})

sample({
  clock: [passCommissionCalculate.doneData, passCommissionUpdate.doneData],
  fn: (doneData) => doneData.body,
  target: setChangedAmountData,
})

sample({
  clock: [passCommissionUpdate.doneData],
  fn: ({}) => true,
  target: setPassCommissionUpdateRequestSuccess,
})

sample({
  clock: [passCommissionCalculate.failData, passCommissionUpdate.failData],
  fn: (failData) => {
    return { message: failData.body.message, code: failData.status }
  },
  target: [setError],
})
